import React from 'react';
import { TrendingUp, Bird, Settings, Plus, Tag } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Badge } from '../../components/ui/badge';

/**
 * Header: selector de lote + badge de fase + botones de acción.
 */
export const CostosHeader = ({
  lotes,
  selectedLoteId,
  setSelectedLoteId,
  selectedLote,
  onOpenFase,
  onOpenCategoria,
  onOpenConfig,
  onNewGasto,
}) => (
  <div className="flex flex-wrap items-center justify-between gap-3">
    <div className="flex items-center gap-3">
      <Select value={selectedLoteId} onValueChange={setSelectedLoteId} data-testid="select-lote-costos">
        <SelectTrigger className="w-[220px] h-11">
          <SelectValue placeholder="Seleccione un lote" />
        </SelectTrigger>
        <SelectContent>
          {lotes
            .map((l) => {
              const loteId = l.id || l._id;
              if (!loteId) return null;
              return (
                <SelectItem key={loteId} value={loteId}>
                  {l.numero_lote} ({l.fase || 'Levante'})
                </SelectItem>
              );
            })
            .filter(Boolean)}
        </SelectContent>
      </Select>
      {selectedLote && (
        <Badge
          variant={selectedLote.fase === 'Postura' ? 'default' : 'secondary'}
          className="text-sm cursor-pointer"
          onClick={onOpenFase}
        >
          {selectedLote.fase === 'Postura' ? (
            <><TrendingUp className="w-3 h-3 mr-1" /> Postura</>
          ) : (
            <><Bird className="w-3 h-3 mr-1" /> Levante</>
          )}
        </Badge>
      )}
    </div>
    <div className="flex flex-wrap gap-2">
      <Button variant="outline" size="sm" onClick={onOpenCategoria}>
        <Tag className="w-4 h-4 mr-1" /> Nueva Categoria
      </Button>
      <Button variant="outline" size="sm" onClick={onOpenConfig} data-testid="btn-config-costos">
        <Settings className="w-4 h-4 mr-1" /> Configuracion
      </Button>
      <Button size="sm" onClick={onNewGasto} data-testid="btn-nuevo-gasto">
        <Plus className="w-4 h-4 mr-1" /> Registrar Gasto
      </Button>
    </div>
  </div>
);
